import Joi from 'joi';

// allow float to be passed. Joi validates that numbers must be within JavaScript's safety range
const Amount = [Joi.string().allow(''), Joi.number()];

export default Amount;
